import React, { FunctionComponent, memo } from 'react'

import { SubjectFeature } from '../../../common/subjectTypes'

export interface SubjectSearchResultTableAddressCellProps {
  record?: SubjectFeature
}

export const SubjectSearchResultTableAddressCell: FunctionComponent<SubjectSearchResultTableAddressCellProps> =
  memo(({ record }) => {
    if (!record?.properties?.ulice || !record?.properties?.adresniMistoKod) {
      return (
        <div
          title="Adresu se nepodařilo zpracovat. Není vyobrazena v mapě."
          className="text-gray-400"
        >
          {record?.properties?.adresa || '-- nenalezeno --'}
        </div>
      )
    }

    return <>{record.properties.ulice}</>
  })
